module.exports = __webpack_public_path__ + "static/BlackCherry-ad239bce3821765e3ab3820cca0aa93b.jpg";